<template>
  <div class="hello">
      <el-table  :data="tableData" border size="mini">
           <el-table-column type="selection" width="55">
            </el-table-column>
          <el-table-column label="日期1" prop="date" width="150">
          </el-table-column>
          <el-table-column label="日期2" prop="name" width="200">
          </el-table-column>
          <el-table-column label="日期3" prop="province"  width="250">
          </el-table-column>
           <el-table-column label="日期3" prop="city"  width="250">
          </el-table-column>
           <el-table-column label="日期3" prop="address"  width="250">
          </el-table-column>
          <el-table-column label="日期3" prop="zip"  width="250">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                <el-button type="text" size="small">编辑</el-button>
            </template>
    </el-table-column>
      </el-table>


      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <span>
            <el-form  label-width="80px" >
                <el-form-item label="名称">
                    <el-input v-model="a_name"></el-input>
                </el-form-item>
                <el-form-item label="活动区域">
                    <el-input v-model="a_province"></el-input>
                </el-form-item>
                <el-form-item label="活动形式">
                    <el-input v-model="a_address"></el-input>
                </el-form-item>
            </el-form>
        </span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
        </el-dialog>

  </div>
</template>

<script>
import {Get_Table_Data} from "@/api/aTable/aTable.js";

export default {
  name: 'table',
  data () {
    return {
        tableData: [],
        dialogVisible:false,
        a_name:"",
        a_province:"",
        a_address:"",
      } 
  },
  created(){
     this.getdata();
  },
  mounted:{},
  methods:{
    getdata(){
       
         Get_Table_Data({}).then(Response =>{
             console.log(Response);
           this.tableData = Response;
       }) ;     

    },
    handleClick(row){
        this.dialogVisible = true;
        this.a_name = row.name;
        this.a_province = row.province;
        this.a_address = row.address;
    } 
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
//<!--3.1、样式区-->
<style type="text/css" scoped>
  /**控制本页边界 */
  .el-form-item {
    margin-bottom: 10px !important;
  }
  .el-table .cell{
    line-height: 14px!important;
  }
  .el-divider--horizontal {
    margin: 10px 0!important;
  }
  .el-dialog__body{
    padding: 0px 20px 20px 20px !important;
  }
  /**解决form无高度问题 */
  .el-form{
    display: inline-block !important;
  }
  .el-table--mini th, .el-table--mini td {
    padding: 0px !important;
  }
  .el-table--small th, .el-table--small td {
    padding: 4px !important;
  }
  .el-table .cell {
    line-height: 16px !important;
  }
  .el-divider--horizontal{
    margin: 12px 0px !important;
  }
  .el-card {
    border-radius: 16px !important;
    background-color: #fdfbf8 !important;
    box-shadow: 1px 1px 2px #888888;
  }
  .el-dialog {
    border-radius: 6px !important;
  }
  .light:hover{
    color: red!important;
  }
  .el-badge__content.is-fixed{
    z-index: 20!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/table.vue